let linkActiveClass = 'uk-active';

export default {
    'loginRoute' : {name : 'user-login'},
    'requiresGuestRedirect' : '/',
    'requiresUserRedirect' : '/user/login',
    'linkActiveClass': linkActiveClass
}
